export default {
  // zy语言配置
  // 2026.7.1
  Buyer_designated_logistics: "买家指定物流",
  You_can_make_an_appointment_for_a_storage_slot_within_the_next_7_days_The_green_dates_indicate_the_available_appointment_periods_and_the_right_side_shows_the_number_of_remaining_slots_available_for_appointment_on_the_current_day_in_real_time_The_red_dates_indicate_that_the_appointment_for_the_current_day_is_already_full_and_no_more_appointments_can_be_made:
    "可预约近7天入库时间，绿色日期为可预约时段，右方实时显示当日剩余可预约方数；红色日期为当日预约已满，无法预约",
  Scheduled_date: "预约日期",
  matching_method: "匹配方式",
  Please_enter_a_numerical_value_The_smaller_the_number_the_higher_the_priority_for_executing_the_matching:
    "请输入数值，数字越小，执行匹配的优先级越高",
  The_selected_times_have_overlaps_Please_reselect:
    "选择的时间存在交集，请重新选择",
  purchase_cost_of_ordered_goods: "订单商品采购成本",
  When_submitting_an_order_the_packaging_material_name_will_be_used_to_match_the_corresponding_packaging_material_in_the_warehouse_Please_check_if_there_is_a_matching_packaging_material_in_the_corresponding_target_warehouse_before_use:
    "提交订单将以包材名去匹配对应仓库的包材，使用时请检查在对应目标仓库有无匹配包材。",
  Remaining_Shipping_Time_For_Order: "订单剩余发货时间",
  editTheListOfProductSKUs: "编辑商品SKU列表", //菜单名称修改时注意
  viewTheListOfProductSKUs: "查看商品SKU列表", //菜单名称修改时注意
  locationTransfer: "移库位", //菜单名称修改时注意
  Create_a_warehouse_entry: "创建入库单",
  Packing_information: "装箱信息",

  offlineRecharge: "线下充值",
};
